import {
    offers,
}  from "../components/offers/store/reducers"

module.exports = offers;
